import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WifiOff, Wifi } from "lucide-react";

export const OfflineIndicator = () => {
  const [online, setOnline] = useState(navigator.onLine);
  const [showRecovered, setShowRecovered] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      setShowRecovered(true);
      setTimeout(() => setShowRecovered(false), 2500);
    };
    const handleOffline = () => setOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <AnimatePresence>
      {!online && (
        <motion.div
          key="offline"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-[60] bg-red-500 text-white text-xs font-bold py-1.5 px-4 flex items-center justify-center gap-2 shadow-lg"
          data-testid="offline-banner"
        >
          <WifiOff className="w-3.5 h-3.5" />
          <span>Hors ligne — certaines fonctions sont limitees</span>
        </motion.div>
      )}
      {showRecovered && online && (
        <motion.div
          key="online"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-[60] bg-emerald-500 text-white text-xs font-bold py-1.5 px-4 flex items-center justify-center gap-2 shadow-lg"
          data-testid="online-banner"
        >
          <Wifi className="w-3.5 h-3.5" />
          <span>Connexion retablie</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
